import { __rest, __assign } from '../../../../_virtual/_tslib.js';
import React from 'react';
import BoxArrow from '../BoxArrow/BoxArrow.js';
import { BoxContainer } from './Box.styles.js';

function Box(_a) {
  var background = _a.background,
      _b = _a.rounded,
      rounded = _b === void 0 ? true : _b,
      padding = _a.padding,
      arrowSpacing = _a.arrowSpacing,
      arrowPlacement = _a.arrowPlacement,
      withArrow = _a.withArrow,
      paddingVertical = _a.paddingVertical,
      children = _a.children,
      props = __rest(_a, ["background", "rounded", "padding", "arrowSpacing", "arrowPlacement", "withArrow", "paddingVertical", "children"]);

  return React.createElement("div", __assign({}, props), withArrow && React.createElement(BoxArrow, {
    arrowPlacement: arrowPlacement,
    arrowSpacing: arrowSpacing,
    background: background
  }), React.createElement(BoxContainer, {
    background: background || 'transparent',
    rounded: rounded,
    padding: padding,
    paddingVertical: paddingVertical
  }, children));
}

export { Box };